import {defineStore} from 'pinia';
import {ref} from 'vue';


export const useRouterStore = defineStore('router', () => {
    const pages = ref([]);

    async function addPage(data) {
        if (!hasPage(data.url)) {
            pages.value.push(data);
        }
    }

    function hasPage(url) {
        return pages.value.findIndex(item => item.url === url) >= 0;
    }

    function getPage(url) {
        return pages.value.find(function (item) {
            let page = item.url === url;
            if (page) {
                return page;
            }

            return pages.value.find(item => url === item.url.replace(/^\/[^\/]*\//, '/'));
        });
    }

    function getCurrentPage() {
        return getPage(useRoute().path);
    }

    return {
        pages,
        addPage,
        hasPage,
        getPage,
        getCurrentPage
    };
});
